// src/components/Modal/Modal.js
// src/components/Form/Modal.js
import React from 'react';
import './Modal.css'; // Estilos para o modal

const Modal = ({ show, onClose, message, titulo="Aviso", children, className = '' }) => {
  if (!show) {
    return null;
  }

  return (
    <div className={`modal-overlay${className ? ` ${className}` : ''}`}>
      <div className="modal-content">
        <h2>{titulo}</h2>
        {message && (<p>{message}</p>)}
        
        {children ? children : (
          <button className="modal-button" onClick={onClose}>
          Fechar
          </button>
        )}
        
      </div>
    </div>
  );
};

export default Modal;
